<div mat-dialog-content>
  <p>{{data.title}}</p>
</div>
<div mat-dialog-actions>
  <button mat-raised-button *ngIf="!data.ok" color="warn" (click)="onNoClick(true)">{{'delete' | translation}}</button>
  <button mat-raised-button *ngIf="data.ok" color="warn" (click)="onNoClick(true)">{{data.ok}}</button>
  <button mat-button *ngIf="!data.cancel" (click)="onNoClick(false)" cdkFocusInitial>{{'cancel' | translation}}</button>
  <button mat-button *ngIf="data.cancel" (click)="onNoClick(false)" cdkFocusInitial>{{data.cancel}}</button>
</div>

<!-- -->
